module.exports = __webpack_public_path__ + "static/img/IMG_20170904_173712.c7bbb591.jpg";